import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import ModalForm from '@/common/components/modal-form';
import TutorialSpotlight from '@/common/components/tutorial-spotlight';
import TransactionForm from './form';
import { getBudgetCats } from '@/utils';
const ADD_TX_STEPS = [
    {
        title: 'Тип операции',
        text: 'Выберите: расход, доход или накопление (если включены). От типа зависит набор категорий.',
        selector: '[data-tut="tx-type"]',
        place: 'bottom',
    },
    {
        title: 'Категория',
        text: 'Привяжите операцию к категории. Это поможет отслеживать расходы на дашборде.',
        selector: '[data-tut="tx-category"]',
        place: 'top',
    },
    {
        title: 'Плановая или фактическая',
        text: 'Плановая — запланированный расход/доход. Фактическая — уже совершённая операция. Плановую можно позже подтвердить в календаре.',
        selector: '[data-tut="tx-plan-toggle"]',
        place: 'top',
    },
    {
        title: 'Регулярная операция',
        text: 'Включите, чтобы создать серию повторяющихся операций — еженедельно или ежемесячно. Все операции серии будут связаны и их можно будет редактировать вместе.',
        selector: '[data-tut="tx-recurrence-toggle"]',
        place: 'top',
    },
];
function AddTxModal({ date, budget, preType, onClose, onAdd }) {
    const [pendingTxs, setPendingTxs] = useState([]);
    const submit = () => {
        if (pendingTxs.length === 0) {
            return;
        }
        onAdd(pendingTxs);
    };
    return (_jsxs(ModalForm, { onSubmit: submit, onClose: onClose, headlineText: "\u041D\u043E\u0432\u0430\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F", submitButtonText: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C", children: [_jsx(TransactionForm, { date: date, savingsEnabled: budget.savingsEnabled, categories: getBudgetCats(budget), onChanged: setPendingTxs, changeDebounceMs: 250, preType: preType, weekStart: budget.weekStart }), _jsx(TutorialSpotlight, { steps: ADD_TX_STEPS, storageKey: "tut_add_tx_v1" })] }));
}
export default AddTxModal;
